// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1VR3f","header":"MergedInvoice_header__3k00n"};